import { omit } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getApiStatus } from '../../../../../core/utils';
import { addEmployee, ADD_EMPLOYEE, fetchEmployees } from '../../../../employees/actions';
import useForm, { Form, FormValues, userFields } from '../../../hooks/useForm';
import useEmployees from '../../ManageUsers/hooks/useEmployees';

type EmployeeFields = Exclude<FormValues, 'userGroupId' | 'coreSites'>;

const useCreateForm = (): Form & { isNew: boolean } => {
  const dispatch = useDispatch();

  const { getEmployees } = useEmployees();

  const isLoading = useSelector((state) => getApiStatus(state, ADD_EMPLOYEE));

  const formatBody = (values: FormValues): FormValues | EmployeeFields => {
    const formattedValues: any = { ...values };

    // Normalize cashierSites to an array of IDs or remove when not a cashier
    if (formattedValues.isCashier && Array.isArray(formattedValues.cashierSites)) {
      formattedValues.cashierSites = formattedValues.cashierSites.map((site: any) => site.id);
    } else {
      delete formattedValues.cashierSites;
    }

    // Normalize coreSites to an array of IDs for backend
    if (Array.isArray(formattedValues.coreSites)) {
      formattedValues.coreSites = formattedValues.coreSites.map((site: any) => site.id);
    }

    // Avoid sending nulls for optional numeric fields
    if (formattedValues.userGroupId == null) delete formattedValues.userGroupId;

    if (!values.loginCredentialsNeeded) {
      return omit(formattedValues, userFields) as EmployeeFields;
    }

    return formattedValues;
  };

  const handleSubmit = (values: FormValues) => {
    const formattedBody = formatBody(values);

    const postBody = {
      data: {
        body: formattedBody,
      },
      closeModal: false,
      callback: () => fetchEmployees({ data: { query: { key: 'id', direction: 'desc' } } }),
    };
    dispatch(addEmployee(postBody));
  };

  const formProps = useForm({
    isLoading,
    onSubmit: handleSubmit,
  });

  return {
    ...formProps,
    isNew: true,
  };
};

export default useCreateForm;
